import { usePost } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { ClosureReasonModel } from '@app/models';

export function useCreateClosureReasons() {
  const post = usePost(true, "tms");
  const createClosureReasons = (request: ClosureReasonModel[]) =>
    post(`${referenceDataBaseUrl}/closure-reasons`, {ClosureReasons: request});

  return useMutationWithErrorHandling({
    mutationFn: async (request: ClosureReasonModel[]) => await createClosureReasons(request),
  });
}
